import { formatCurrency } from "../utils/SaitUtils";

/*
	Obbligatori:
		headerName
		field
	Facoltativi:
		width
*/

export default function SaitCurrencyColumn(props) {
	return {
		headerName: props.headerName,
		width: props.width,
		field: props.field,
		hidden: props.hidden || false,
		flex: props.flex,
		columnType: "currency",
		type: "number",
		renderCell: props.renderCell,
		valueGetter: props.valueGetter,
		valueFormatter: (value, row, column, apiRef) => (value || value === 0 ? formatCurrency(value) : value),
		objmod: props.objmod,
		startPinned: props.startPinned,
		endPinned: props.endPinned,
	};
}
